import { useEffect } from 'react';

interface PageSEOProps {
  title: string;
  description: string;
  canonicalPath?: string;
}

export default function PageSEO({ title, description, canonicalPath }: PageSEOProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, attrName = 'name') => {
      let el = document.querySelector(`meta[${attrName}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attrName, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);

    if (canonicalPath) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = `https://spiritualhealing.cn${canonicalPath}`;
    }

    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    if (canonicalPath) {
      setMeta('og:url', `https://spiritualhealing.cn${canonicalPath}`, 'property');
    }
    setMeta('twitter:title', title, 'name');
    setMeta('twitter:description', description, 'name');
  }, [title, description, canonicalPath]);

  return null;
}